import React from 'react';
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import About from './components/About';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import NewSales from './components/NewSales';
import OrderHistory from './components/OrderHistory';
import CreateManifest from './components/CreateManifest';
import DataTable from './components/DataTable';
import ManifestList from './components/ManifestList';
import ManifestPrint from './components/dispatch/ManifestPrint';
//import MarkDelivery from './components/MarkDelivery';
import NewMarkDelivery from './components/NewMarkDelivery';
import OpenTrips from './components/OpenTrips';
import OpenTripSummary from './components/OpenTripSummary';
import CompleteTrips from './components/CompleteTrips';
import CloseTripSummary from './components/CloseTripSummary';
import ReturnList from './components/Return/ReturnList';
import SalesView from './components/SalesView';
//picking start
import PickingCreate from './components/picking/PickingCreate';
import PickingList from './components/picking/PickingList';
import SinglePickingList from './components/picking/SinglePickinglist';

import EditPicking from './components/picking/EditPicking';
import PickingHistory from './components/picking/PickingHistory';
import ViewPicking from './components/picking/ViewPicking';
import ShortQty from './components/picking/ShortQty';
import ViewShortQty from './components/picking/ViewShortQty';
import ConfirmShortQty from './components/picking/ConfirmShortQty';
import Proforma from './components/picking/Proforma';
import ProformaInvoice from './components/picking/ProformaInvoice';
import ViewPickingList from './components/picking/ViewPickingList';
import SingleViewPickinglist from './components/picking/SingleViewPickinglist';


//picking End
import CommonDatePicker from './components/datepicker/CommonDatePicker';
import Edit_New_Invoice from './components/Edit_New_Invoice';
import AddReturn from './components/Return/AddReturn';
import RoutePlaningInvoice from './components/RoutePlaningInvoice';
import CloseTripSummeryReport from './components/ClosedTripSummary';
import ClosedTripSummary from './components/ClosedTripSummary';
import ModalComponent from './components/ModalComponent';
import TableComponent from './components/TableComponent';
import Products from './components/Master/Products/Products';
import Add_Products from './components/Master/Products/Add_Products';
import Edit_Product from './components/Master/Products/Edit_Product';
import Previous_Product from './components/Master/Products/PreviousProduct';
import Supplier from './components/Master/Supplier/Supplier';
import Add_Supplier from './components/Master/Supplier/Add_Supplier';
import Edit_Supplier from './components/Master/Supplier/Edit_Supplier';
import Customers from './components/Master/Customers/Customers';
import Edit_Customer from './components/Master/Customers/Edit_Customer';
import Contra_Price from './components/Master/Customers/ContraPrice';
import ContraList from './components/Master/Customers/ContraList';
import Contra_Price_Edit from './components/Master/Customers/Contra_Price_Edit';
import Users from './components/Master/Users/Users';
import User_Profile from './components/Master/Users/User_Profile';
import Brands from './components/Master/Brands/Brands';
import Units from './components/Master/Units/Units';
import Product_Category from './components/Master/Product_Category';
import Products_Price_Variation from './components/Master/PriceVariation/Products_Price_Variation';
import Customer_Credit_Facility from './components/Master/CustomerCredit/Customer_Credit_Facility';
import CustomerNotOrderReport from './components/reports/CustomerNotOrderReport';
import MisReport from './components/reports/MisReport';
import MisProductReport from './components/reports/MisProductReport';
import InventorySalesReport from './components/reports/InventorySalesReport';
import PurchaseReport from './components/reports/PurchaseReport';
import CrossOffReport from './components/reports/CrossOffReport';
import SalesRepReport from './components/reports/SalesRepReport';
import DsrReport from './components/reports/DsrReport';
import ProfitLossReport from './components/reports/ProfitLossReport';
import StockReport from './components/reports/StockReport';
import BatchWiseStockReport from './components/reports/BatchWiseStockReport';
import BatchWiseStockDetailsReport from './components/reports/BatchWiseStockDetailsReport';
import NewRSales from './components/nsales/NewRSales';
import HoldList from './components/nsales/HoldList';
import SalesOrderHistory from './components/nsales/SalesOrderHistory';
import EditSalesInvoice from './components/nsales/EditSalesInvoice';
import EditSalesInvoice_Sdm from './components/nsales/EditSalesInvoice_Sdm';
import Edit_delivered_invoice from './components/trip/Edit_delivered_invoice';
import Edit_delivered_invoice_sdm from './components/trip/Edit_delivered_invoice_sdm';
import RejectSales from './components/nsales/RejectSales';
import SummaryPrint from './components/trip/SummaryPrint';
import MultipleSummaryPrint from './components/trip/MultipleSummaryPrint';
import OrderSummaryPrint from './components/nsales/OrderSummaryPrint';
import monthsales from './components/dashboard/MonthSalesList';
import CreateNewManifest from './components/dispatch/CreateNewManifest';
import CreateManifestPrint from './components/dispatch/CreateManifestPrint';
import { StockTakeHistory, StockTakeHistoryList, StockTakeList, StartStockTake } from './components/stockTake';
import { PurchasesOrder, PurchasesHistory, PurchasesAddFrom, EditPurchasesFrom, SuggestedPO, PurchaseViewPrint, AddPurchasesGRN, PurchaseHistoryViewPrint } from './components/purchases';
import { PushSage, AllPushInvoice, PaymentProcess, CustomerAccounts, SupplierLedger, PaymentLadger, MyLadger, ProductLadger, ProductLadgerView } from './components/account';
import AmountDueCustomer, { CustomerAccountsList } from './components/account/AmountDueCustomerList';
import Promos from './components/Promotions/Promos';
import Add_Promos from './components/Promotions/Add_Promos';
import Edit_Promos from './components/Promotions/Edit_Promos';
import Create_similar_promo from './components/Promotions/Create_similar_promo';
import Slider_settings from './components/slider_settings/Slider_settings';
import Catalogue from './components/Catalogue/Catalogue';
import Epos from './components/sales/Epos';
import EposSales from './components/sales/EposSales';
import Inventory_Report from './components/sales/Inventory_Report';
import StockAdjustment from './components/purchases/StockAdjustment';

// import Group_Permissions from './components/Settings/Group_Permissions';
// import Change_Permissions from './components/Settings/Change_Permissions';
import Application_Setting from './components/Settings/Application_Setting';
import ReturnListPrint from './components/Return/ReturnListPrint';
// import Finish_Pay from './components/sales/Finish_Pay';
// import Incomplete_Order from './components/sales/Incomplete_Order';
import NewSalesDashbard from './components/dashboard/NewSales';
import SalesOrderDashbard from './components/dashboard/SaleOrder';
import DeliveredInvoice from './components/dashboard/DeliveredInvoice';
import InprogressInvoice from './components/dashboard/InprogressInvoice';
import OrderAccepted from './components/dashboard/OrderAccepted';
import PicklistGenerated from './components/dashboard/PicklistGenerated';
import PickingConfirm from './components/dashboard/PickingConfirm';
import TopSales from './components/dashboard/TopSales';
import MaxValueOrder from './components/dashboard/MaxValueOrder';
import ManifestGenerated from './components/dashboard/ManifestGenerated';
import DeliveryConfirmed from './components/dashboard/DeliveryConfirmed';
import OrderLocationReport from './components/reports/OrderLocationReport';
import SalesProductReport from './components/reports/SalesProductReport';
// import GroupPermissions from  './components/Settings/GroupPermissions';
// import ChangePermissions from  './components/Settings/ChangePermissions';
import NewSalesInvoice from './components/nsales/NewSalesInvoice';
import PurchaseOrderInvoice from './components/purchases/PurchaseOrderInvoice';
import EditProforma from './components/proforma/EditProforma';
import EditProforma_sdm from './components/proforma/EditProforma_Sdm';

import Registration from './components/Settings/Registration';
import Common_Invoice from './components/nsales/Common_Invoice';
import Temp from './components/Temp';
import NewFile from './components/nsales/NewFile';
import PaymentAllocation from './components/account/InvoicePaymentAllocation';
import Cashier_Report from './components/reports/Cashier_Report';
import ExpiryReport from './components/reports/ExpiryReport';
import Order_Receipt_sticker from './components/sales/Order_Receipt_sticker';
import Price_sticker from './components/Master/Products/Price_sticker';
import Promotion_Sale_slip from './components/Promotion_Sale_slip';
import IncompleteOrderList from './components/sales/IncompleteOrderList';
import Quick_Order from './components/sales/Quick_Order';
import Invoice_Format from './components/Invoice_Format';
import Customer_Onboarding from './components/Customer_Onboarding';

import BarcodeScannerComponent from './components/sales/BarcodeScannerComponent';
import EmailTemplate from './components/Email_template/EmailTemplateEditor';

//Shopify API
import ShopifyCategories from './components/picking/ShopifyCategories';
import ShopifyProductList from './components/picking/ShopifyProduct';
import AmazonProductList from './components/amazon/AmazonProduct';

import MapRoute from './components/dispatch/MapRoute';
import PaymentCollection from './components/reports/PaymentCollection';
import ChangePermissions from './components/Settings/ChangePermissions';
import CompanySettings from './components/Settings/CompanySettings';

import TransactionsReport from './components/reports/TransactionsReport';
import DaySummaryReport from './components/reports/DaySummaryReport';

import PurchaseOrderReport from './components/reports/PurchaseOrderReport';
import SalesOrderReport from './components/reports/SalesOrderReport';
import CatalogueNew from './components/Catalogue/CatalogueNew';
import "./assets/common-button.css";
import "./assets/main.css";
import NotFound from './components/error/NotFound';



// The basename is set to '/react' for deployment to a subdirectory

function App() {
  return (
    <Router basename="/">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/BarcodeScannerComponent" element={<BarcodeScannerComponent />} />
        <Route path="/DataTable" element={<DataTable />} />
        <Route path="/login" element={<Login />} />
        <Route path="/About" element={<About />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/:prefix/:userId" element={<Dashboard />} />
        <Route path="/new_sales" element={<NewSales />} />
        <Route path="/order_history" element={<OrderHistory />} />
        <Route path="/create_manifest" element={<CreateManifest />} />
        <Route path="/route_planing_invoice" element={<RoutePlaningInvoice />} />
        <Route path="/manifest_list" element={<ManifestList />} />
        <Route path="/manifest_list/ManifestPrint/:manifestId" element={<ManifestPrint />} />
        <Route path="/manifest_list/mark_delivery/:manifestId" element={<NewMarkDelivery />} />
        <Route path="/demoModal/:manifestId" element={<ModalComponent />} />
        <Route path="/open_trips" element={<OpenTrips />} />
        <Route path="/open_trips/trip_summary/:tripId" element={<OpenTripSummary />} />
        <Route path="/complete_trips" element={<CompleteTrips />} />
        <Route path="/complete_trips/closed_trip_summary/:tripId" element={<CloseTripSummary />} />
        <Route path="/closed_trip_summary/:tripId" element={<CloseTripSummeryReport />} />
        <Route path="/return_list" element={<ReturnList />} />
        <Route path="/sales_view" element={<SalesView />} />
        <Route path="/picking/picking_create" element={<PickingCreate />} />
        <Route path="/picking/picking_list" element={<PickingList />} />
        <Route path="/picking/single_picking_list" element={<SinglePickingList />} />
        <Route path="/picking/edit_picking/:picklistNo" element={<EditPicking />} />
        <Route path="/picking/picking_history" element={<PickingHistory />} />
        <Route path="/picking/short_qty" element={<ShortQty />} />
        <Route path="/picking/view_short_qty/:picklistNo" element={<ViewShortQty />} />
        <Route path="/picking/confirm_short_qty/:picklistNo/:productId/:orderType" element={<ConfirmShortQty />} />
        <Route path="/picking/proforma" element={<Proforma />} />
        <Route path="/picking/view_picking/:picklistNo" element={<ViewPicking />} />
        <Route path="/sales/view_picking_list/:picklistNo" element={<ViewPickingList />} />
        <Route path="/sales/single_view_picking_list/:picklistNo" element={<SingleViewPickinglist />} />

        <Route path="/DateRangePicker" element={<CommonDatePicker />} />
        <Route path="/proforma_invoice" element={<ProformaInvoice />} />
        <Route path="/edit_new_invoice" element={<Edit_New_Invoice />} />
        <Route path="/return/add_return" element={<AddReturn />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products/add_product" element={<Add_Products />} />
        <Route path="/products/edit/:productId" element={<Edit_Product />} />
        <Route path="/products/previous_pricing/:productId" element={<Previous_Product />} />
        <Route path="/supplier" element={<Supplier />} />
        <Route path="/supplier/add_supplier" element={<Add_Supplier />} />
        <Route path="/supplier/edit_supplier/:supplierId" element={<Edit_Supplier />} />
        <Route path="/customers" element={<Customers />} />
        <Route path="/ContraList" element={<ContraList />} />
        <Route path="/customer/edit_customer/:customerId" element={<Edit_Customer />} />
        <Route path="/customer/contra_price/:customerId" element={<Contra_Price />} />
        <Route path="/customers/contra_price_edit/:customerId" element={<Contra_Price_Edit />} />
        <Route path="/users" element={<Users />} />
        <Route path="/user/edit_profile/:userId" element={<User_Profile />} />
        <Route path="/Brands" element={<Brands />} />
        <Route path="/Units" element={<Units />} />
        <Route path="/product_category" element={<Product_Category />} />
        <Route path="/products_price_variation" element={<Products_Price_Variation />} />
        <Route path="/Customer_Credit_Facility" element={<Customer_Credit_Facility />} />
        <Route path="/testTable" element={<TableComponent />} />
        <Route path="reports/customer_not_order_report" element={<CustomerNotOrderReport />} />
        <Route path="reports/mis_report" element={<MisReport />} />
        <Route path="reports/mis_product_report" element={<MisProductReport />} />
        <Route path="reports/inventory_sales_report" element={<InventorySalesReport />} />

        <Route path="reports/purchase_report" element={<PurchaseReport />} />

        <Route path="reports/missing_order" element={<CrossOffReport />} />
        <Route path="reports/sales_report" element={<SalesRepReport />} />
        <Route path="reports/dsr_report" element={<DsrReport />} />
        <Route path="reports/profit_loss_report" element={<ProfitLossReport />} />
        <Route path="reports/stock_report" element={<StockReport />} />
        <Route path="reports/batchWise_stock_report" element={<BatchWiseStockReport />} />
        <Route path="reports/batchWise_stock_details_report/:id" element={<BatchWiseStockDetailsReport />} />
        <Route path="sales/newsales" element={<NewRSales />} />
        <Route path="sales/holdList" element={<HoldList />} />
        <Route path="sales/shistory" element={<SalesOrderHistory />} />
        <Route path="sales/reject_sales" element={<RejectSales />} />
        <Route path="/sales/edit_invoice/:orderId" element={<EditSalesInvoice />} />
        <Route path="/sales/edit_invoice_sdm/:orderId" element={<EditSalesInvoice_Sdm />} />
        <Route path="/trip/Edit_delivered_invoice/:tripId/:orderId" element={<Edit_delivered_invoice />} />
        <Route path="/trip/Edit_delivered_invoice_sdm/:tripId/:orderId" element={<Edit_delivered_invoice_sdm />} />
        <Route path="/trip_summary/print/MultipleSummaryPrint" element={<MultipleSummaryPrint />} />
        <Route path="/trip_summary/print/:orderId" element={<SummaryPrint />} />
        <Route path="/reports/mis_report/print/:orderId" element={<SummaryPrint />} />
        <Route path="/picking/picking_list/view/:orderId" element={<SummaryPrint />} />
        <Route path="order_summary/print/:orderId" element={<OrderSummaryPrint />} />
        <Route path="/monthsales" element={<monthsales />} />
        <Route path="delivery/route_planing" element={<CreateNewManifest />} />
        <Route path="/delivery/route_planing/view/:orderId" element={<CreateManifestPrint />} />
        <Route path="stock_take/history" element={<StockTakeHistory />} />
        <Route path="/products/show_history_of_stock_take_list/:stockId" element={<StockTakeHistoryList />} />
        <Route path="stock_take/stock_take_list" element={<StockTakeList />} />
        <Route path="stock_take/start_stock_take" element={<StartStockTake />} />
        <Route path="purchases/purchases_order" element={<PurchasesOrder />} />
        <Route path="purchases/purchases_grn" element={<PurchasesHistory />} />
        <Route path="purchases/add" element={<PurchasesAddFrom />} />
        <Route path="purchases/stockAdjustment" element={<StockAdjustment />} />
        <Route path="/purchases/edit_po/:orderId" element={<EditPurchasesFrom />} />
        <Route path="/purchases/suggested" element={<SuggestedPO />} />
        <Route path="/purchases/view/:orderId" element={<PurchaseViewPrint />} />
        <Route path="/purchases/view_grn/:orderId" element={<PurchaseHistoryViewPrint />} />
        <Route path="/purchases/add_grn/:orderId" element={<AddPurchasesGRN />} />
        <Route path="account/push_sage" element={<PushSage />} />
        <Route path="account/push_invoice" element={<AllPushInvoice />} />
        <Route path="account/payments" element={<PaymentProcess />} />
        <Route path="account/customer_accounts" element={<CustomerAccounts />} />
        <Route path="account/amount_due_customer" element={<AmountDueCustomer />} />
        <Route path="account/supplier_ledger" element={<SupplierLedger />} />
        <Route path="account/payment_ladger" element={<PaymentLadger />} />
        <Route path="account/my_ledger" element={<MyLadger />} />
        <Route path="Promotions/Promos" element={<Promos />} />
        <Route path="Promotions/Create_similar_promo/:id" element={<Create_similar_promo />} />
        <Route path="/Promotions/Add_Promos" element={<Add_Promos />} />
        <Route path="/Promotions/Edit_Promos" element={<Edit_Promos />} />
        <Route path="slider_settings" element={<Slider_settings />} />
        <Route path="/Promotions/Edit_Promos/:id" element={<Edit_Promos />} />
        <Route path="Catalogue" element={<Catalogue />} />
        <Route path="sales/Epos" element={<Epos />} />
        <Route path="sales/epos_sales" element={<EposSales />} />
        <Route path="dashboard/NewSales" element={<NewSalesDashbard />} />
        <Route path="dashboard/DeliveredInvoice" element={<DeliveredInvoice />} />
        <Route path="dashboard/InprogressInvoice" element={<InprogressInvoice />} />
        <Route path="dashboard/SalesOrder" element={<SalesOrderDashbard />} />
        <Route path="dashboard/OrderAccepted" element={<OrderAccepted />} />
        <Route path="dashboard/picklistGenerated" element={<PicklistGenerated />} />
        <Route path="dashboard/PickingConfirm" element={<PickingConfirm />} />
        <Route path="dashboard/TopSales" element={<TopSales />} />
        <Route path="dashboard/MaxValueOrder" element={<MaxValueOrder />} />
        <Route path="dashboard/ManifestGenerated" element={<ManifestGenerated />} />
        <Route path="dashboard/DeliveryConfirmed" element={<DeliveryConfirmed />} />
        <Route path="account/product_ledger" element={<ProductLadger />} />
        <Route path="payments/view_product_ledger/:productId/:startDate/:endDate/:orderType" element={<ProductLadgerView />} />
        {/* <Route path="sales/Finish_Pay" element={<Finish_Pay />} />
        <Route path="sales/Incomplete_Order" element={<Incomplete_Order />} /> */}
        <Route path="/returns/view/:orderId" element={<ReturnListPrint />} />
        <Route path="/reports/lat_long_report" element={<OrderLocationReport />} />
        <Route path="/reports/sales_product_report" element={<SalesProductReport />} />
        <Route path="new_sales/invoice/:orderId" element={<NewSalesInvoice />} />
        <Route path="purchaseOrder/invoice/:orderId" element={<PurchaseOrderInvoice />} />
        <Route path="edit/proforma/:orderId" element={<EditProforma />} />
        <Route path="edit/proforma_sdm/:orderId" element={<EditProforma_sdm />} />
        <Route path="Settings/Registration" element={<Registration />} />
        <Route path="sales/Common_Invoice" element={<Common_Invoice />} />
        <Route path="Temp" element={<Temp />} />
        <Route path="storepdf/:orderId" element={<NewFile />} />
        <Route path="payments/payment_allocation/:customer_id" element={<PaymentAllocation />} />
        <Route path="reports/Cashier_Report" element={<Cashier_Report />} />
        <Route path="reports/Expiry_report" element={<ExpiryReport />} />
        <Route path="sales/Order_Receipt_sticker" element={<Order_Receipt_sticker />} />
        <Route path="product/price_sticker/:product_id" element={<Price_sticker />} />
        <Route path="Promotion_Sale_slip" element={<Promotion_Sale_slip />} />
        <Route path="sales/InventoryReport" element={<Inventory_Report />} />

        <Route path="sales/IncompleteOrderList" element={<IncompleteOrderList />} />
        <Route path="sales/Quick_Order" element={<Quick_Order />} />

        <Route path="/Invoice_Format" element={<Invoice_Format />} />
        <Route path="/EmailTemplate" element={<EmailTemplate />} />
        <Route path="/Customer_Onboarding" element={<Customer_Onboarding />} />

        <Route path="/shopifyCategoryList" element={<ShopifyCategories />} />
        <Route path="/shopifyProductList" element={<ShopifyProductList />} />
        <Route path="/amazonProductList" element={<AmazonProductList />} />
        <Route path="/manifest/:manifestId/map" element={<MapRoute />} />
        <Route path="/reports/payment_collection" element={<PaymentCollection />} />
        <Route path="/settings/change_permissions" element={<ChangePermissions />} />
        <Route path="/settings/change_permissions/:roleId" element={<ChangePermissions />} />
        <Route path="/dashboard/company-settings" element={<CompanySettings />} />
        <Route path="reports/TransactionsReport" element={<TransactionsReport />} />
        <Route path="reports/DaySummaryReport" element={<DaySummaryReport />} />

        <Route path="reports/PurchaseOrderReport" element={<PurchaseOrderReport />} />
        <Route path="reports/SalesOrderReport" element={<SalesOrderReport />} />
        <Route path="*" element={<NotFound />} />

        
        
      </Routes>
    </Router>
  );
}
/*
const container = document.getElementById("root");
const root = createRoot(container);

root.render(
 <React.StrictMode>
    <App />
 </React.StrictMode>
);*/


const container = document.getElementById('root');

// Create a root element using `createRoot`
const root = createRoot(container);

// Render the app using the root
root.render(
  /* <React.StrictMode>*/
  <App />
  /* </React.StrictMode>*/
);

//serviceWorkerRegistration.unregister();
